var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M1.606 18a3 3 0 0 0 4.097 1.102l.003-.002.445-.257A8.98 8.98 0 0 0 9 20.487V21a3 3 0 0 0 6 0v-.513a8.977 8.977 0 0 0 2.848-1.646l.447.258a3.002 3.002 0 0 0 3-5.2l-.444-.256a9.1 9.1 0 0 0 0-3.29l.444-.256a3.002 3.002 0 0 0-3-5.2l-.445.257A8.977 8.977 0 0 0 15 3.513V3a3 3 0 1 0-6 0v.513a8.976 8.976 0 0 0-2.848 1.646L5.704 4.9a3.002 3.002 0 1 0-3 5.2l.444.256a9.1 9.1 0 0 0 0 3.29l-.444.256A3.006 3.006 0 0 0 1.606 18ZM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrSettings);
export default __webpack_public_path__ + "static/media/fi-sr-settings.73aed3db495484c07fede9aecc770acc.svg";
export { ForwardRef as ReactComponent };